



































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import { InsertTeam, UpdateTeam } from "@/api/pdTeam";
import { GetCommunityAll } from "@/api/pdCommunity";
@Component
export default class TeamDetail extends AbpBase {
  @Prop() data: any;
  model: any = {};
  communityList: any = [];
  rules = {
    code: [
      {
        required: true,
        message: "团队编码不能为空",
        trigger: "blur"
      }
    ],
    name: [
      {
        required: true,
        message: "团队名称不能为空",
        trigger: "blur"
      }
    ],
    communityId: [
      {
        required: true,
        type: "number",
        message: "请选择团队所属社区",
        trigger: "change"
      }
    ]
  };

  created() {
    this.initDic();
  }

  async initDic() {
    let res = await GetCommunityAll();
    this.communityList = res.objects;
  }

  @Watch("data", { immediate: true, deep: true })
  onDataChanged() {
    if (this.data) {
      this.model = Object.assign({}, this.data);
    }
  }

  async submit() {
    let validResult = false;
    this.$refs["form"].validate(valid => {
      if (valid) {
        validResult = true;
      }
    });
    if (validResult) {
      if (this.model.id == 0) {
        await InsertTeam(this.model);
      } else {
        await UpdateTeam(this.model);
      }
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/team/detail.vue